import React, { useEffect, useState } from "react";
import Carousel from "react-bootstrap/Carousel";

const Infographic = (props) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const form = new FormData();
    form.append("getInfographic", 1);
    form.append("vitrinCode", props.vitrinCode);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: form,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        setData(data);
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  if (data.imgNum > 0) {
    return (
      <div className="mt-3">
        <Carousel controls={true} interval={null}>
          {data.images.map((item, index) => (
            <Carousel.Item key={index}>
              <img className="d-block w-100 h-50" src={item} alt={item} />
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    );
  } else {
    return null;
  }
};

export default Infographic;
